import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { Dropdown, DropdownContent, useDropdown } from 'ziphy-web-shared/basic/lib/functional';
import { usePsPatientLink } from '@ps/hooks';
import { $psPatient } from '@store';
import styles from './ChangePsPatientPractice.module.scss';
const ChangePsPatientPractice = () => {
    const psPatientLink = usePsPatientLink();
    const { filteredItems } = useDropdown(useMemo(() => $psPatient.practices.map((item) => ({
        id: item.zid,
        label: item.name,
        selected: item.isCurrent,
        autoTarget: psPatientLink({ practiceId: item.zid }),
    })), [$psPatient.practices]));
    const currentPractice = $psPatient.practices.find((x) => x.isCurrent);
    if (!currentPractice)
        return _jsx(_Fragment, {});
    return (_jsx(Dropdown, Object.assign({ renderButton: ({ fieldRef, onToggle }) => (_jsx("div", Object.assign({ ref: fieldRef, onClick: onToggle, className: styles.dropdownButton }, { children: _jsx("div", { children: currentPractice.name }) }))), direction: ['bottom'], maxWidth: 420 }, { children: _jsx(DropdownContent, { items: filteredItems, classNameItem: styles.dropdown }) })));
};
export default observer(ChangePsPatientPractice);
